export const NAVIGATE_AUTH = {
    AUTH: "/auth",
    LOGIN: "/login",
    LOGOUT: "/logout",
    RESET_PASSWORD: "/reset-password",
    get LOGIN_PAGE() { return `${this.AUTH}${this.LOGIN}`; },
    get LOGOUT_PAGE() { return `${this.AUTH}${this.LOGOUT}`; },
    get RESET_PASSWORD_PAGE() { return `${this.AUTH}${this.RESET_PASSWORD}`; },
}

export const ERROR = {
    ERROR_403: "/403",
    get ERROR_403_PAGE() { return `${this.ERROR_403}`; },
}
export const NAVIGATE_GUEST = {
    HOME: "/",
    ABOUT_US: "/about-us",
    NEWS: "/news-updates",
    HELP: "/help",

    TERMS_CONDITIONS: '/terms-conditions',
    PRIVACY_POLICY: '/privacy-policy',
    COPYRIGHT_POLICY: '/copyright-policy',
    DISCLAIMER: '/disclaimer',
    HYPERLINK_POLICY: '/hyperlink-policy',
}

export const NAVIGATE_REGISTER = {
    REGISTER: "/register",
    DONNER: "/donor-registration",
    IMPLEMENTATION_PARTNER: "/implementing-registration",
    GOVERMENT_REGISTER: "/government-registration",
    HOSPITAL_REGISTER: "/hospital-registration",

    get DONNER_PAGE() { return `${this.REGISTER}${this.DONNER}`; },
    get IMPLEMENTATION_PARTNER_PAGE() { return `${this.REGISTER}${this.IMPLEMENTATION_PARTNER}`; },
    get GOVERMENT_REGISTER_PAGE() { return `${this.REGISTER}${this.GOVERMENT_REGISTER}`; },
    get HOSPITAL_REGISTER_PAGE() { return `${this.REGISTER}${this.HOSPITAL_REGISTER}`; },
}

export const NAVIGATE_ADMIN = {
    ADMIN: "/admin",

    USER_PROFILE: "/user-profile",
    USER_LIST: "/user/list",
    DONOR_LIST: "/user/donor",
    IMPL_AGENCY_LIST: "/user/implementing-agency",
    GOV_LIST: "/user/government",
    HOSPITAL_LIST: "/user/hospital",

    PROJECT_DASHBOARD: "/dashboard",

    TRI_PARTY_DASHBOARD: '/dashboard/tri-party',
    REGISTERED_USER_DETAILS: "/user/details",


    IMPLEMNETING_LIST: "/registered-agencies",
    WORKFLOW_LIST: "/workflow-list",

    BENEFICIARIES_LIST: "/beneficiaries",
    BENEFICIARIES_DETAILS: "/beneficiary/details",

    TRI_PARTY_MOU_LIST: '/tri-party-mou',
    TRI_PARTY_MOU_DETAILS: '/tri-party-mou/details',
    TRI_PARTY_MOU_BENEFICIARY: '/mou-beneficiaries',
    TRI_PARTY_MOU_BENEFICIARY_DETAILS: '/mou-beneficiaries/details',

    COLLABORATIVE_AGREEMENT_LIST: '/collaboration-agreement',
    COLLABORATIVE_AGREEMENT_DETAILS: '/collaboration-agreement/details',
    COLLABORATIVE_AGREEMENT_BENEFICIARIES: "/collaboration-agreement/agreement-beneficiaries",
    AGREEMENT_BENEFICIARIES_LIST: "/agreement-beneficiaries",


    FINANCIAL_MANAGEMENT: "/financial-management/fund-disbursement-utilization",
    FINANCIAL_MANAGEMENT_OVERVIEW: "/financial-management/financial-management-overview",
    ROLES_MASTER: "/master/roles",
    IA_AGENCY: "/implementing_agency",
    IA_AGENCY_LIST: "/implementing-agencies",
    IA_AGENCY_MAPPED_LIST: "/implementing-agency/mapped-projects",
    MENU_MASTER: "/master/menu",
    PERMISSION_MASTER: "/master/menu/permission",
    WORKFLOW_MASTER: "/master/workflow",
    HELP_SUPPORTS: "/help-support",

    get USER_PROFILE_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USER_PROFILE}` },

    get PROJECT_DASHBOARD_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PROJECT_DASHBOARD}` },
    get TRI_PARTY_DASHBOARD_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.TRI_PARTY_DASHBOARD}` },

    get REGISTERED_USER_DETAILS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.REGISTERED_USER_DETAILS}` },
    get TRI_PARTY_MOU_DETAILS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.TRI_PARTY_MOU_DETAILS}` },

    get COLLABORATIVE_AGREEMENT_DETAILS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.COLLABORATIVE_AGREEMENT_DETAILS}` },
    get TRI_PARTY_MOU_BENEFICIARY_DETAILS_PAGE() {
        return `${NAVIGATE_ADMIN.ADMIN}${this.TRI_PARTY_MOU_BENEFICIARY_DETAILS}`
    },
    get COLLABORATIVE_AGREEMENT_BENEFICIARIES_PAGE() {
        return `${NAVIGATE_ADMIN.ADMIN}${this.COLLABORATIVE_AGREEMENT_BENEFICIARIES}`
    },
    get AGREEMENT_BENEFICIARIES_LIST_PAGE() {
        return `${NAVIGATE_ADMIN.ADMIN}${this.AGREEMENT_BENEFICIARIES_LIST}`
    },
    get BENEFICIARIES_DETAILS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.BENEFICIARIES_DETAILS}` },
    get COLLABORATIVE_AGREEMENT_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.COLLABORATIVE_AGREEMENT_LIST}` },
    get USER_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USER_LIST}` },
    get DONOR_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.DONOR_LIST}` },
    get IMPL_AGENCY_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.IMPL_AGENCY_LIST}` },
    get GOV_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.GOV_LIST}` },
    get HOSPITAL_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.HOSPITAL_LIST}` },
    get IA_AGENCY_MAPPED_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.IA_AGENCY_MAPPED_LIST}` },
    get FINANCIAL_MANAGEMENT_OVERVIEW_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.FINANCIAL_MANAGEMENT_OVERVIEW}` },

}

export const NAVIGATE_PROJECT = {
    PROJECTS: "/project",
    PROJECTS_LIST: "/project-listing",
    AGENCY_PROJECTS_LIST: "/agency-projects",
    DONOR_PROJECTS_LIST: "/donor-projects",
    My_PROJECTS: "/my-projects",
    COMPLETED_PROJECTS: "/projects/completed-projects",
    My_INTERESTED_PROJECTS: "/projects/my-interested",
    My_COMMITED_PROJECTS: "/projects/my-committed",
    My_ONGOING_PROJECTS: "/projects/ongoing",
    All_COMMITTED_PROJECTS: "projects/all-commitements",
    PROJECTS_CREATE_FORM: "/project-creation",
    PROJECTS_APPROVAL: "/approval-pending",
    PROJECTS_DETAILS: "/project-details",

    get AGENCY_PROJECTS_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.AGENCY_PROJECTS_LIST}` },
    get DONOR_PROJECTS_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.DONOR_PROJECTS_LIST}` },
    get PROJECTS_LIST_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.PROJECTS_LIST}` },
    get My_INTERESTED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.My_INTERESTED_PROJECTS}` },
    get My_COMMITED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.My_COMMITED_PROJECTS}` },
    get ALL_COMMITED_PROJECTS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}/${this.All_COMMITTED_PROJECTS}` },
}

export const NAVIGATE_KNOWLEDGE_BASE = {
    KNOWLEDGE_LIST: "/knowledge-base",
    KNOWLEDGE_BASE_DETAILS: "/knowledge-base/details",

}

export const NAVIGATE_EVENT_AND_MEDIA = {
    EVENTANDMEDIA: "/event-and-media",
    MEDIA: "/event-and-media/media-gallery",
    PAST_EVENTS: "/event-and-media/past-events",
    UPCOMING_EVENTS: "/event-and-media/upcoming-events",
    UPCOMING_EVENTS_DETAILS: "/event-and-media/upcoming-events-details",
    ADD_EVENT: "/event-and-media/add-upcomming-event"
}

export const NAVIGATE_NOTIFICATION = {
    NOTIFICATION_DETAILS: "/notification-details",

}
export const NAVIGATE_TENDER = {
    TENDER_LIST: "/tender-list",

}

export const NAVIGATE_USERS = {
    USERS: "/users",
    ALL_USERS: "/company-users",
    get USERS_PAGE() { return `${NAVIGATE_ADMIN.ADMIN}${this.USERS}`; },
}


export const NAVIGATE_DONOR_DASHBOARD = {
    DONOR: "/donor-dashboard",
}


export const NAVIGATE_GOV_DASHBOARD = {
    GOV_DASHBOARD: "/gov-agency-dashboard",
}